import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/es';
import * as ReactBootStrap from 'react-bootstrap';
import $ from 'jquery';
import logoMedicall from '../tools/images/logomedicall24horizontal.svg';
import '../tools/css/AgendaCalendario.css';

const ApiURL=process.env.REACT_APP_API_URL;

const PX_POR_MINUTO = 90 / 60;
const UMBRAL_DISPONIBLE_MIN = 10;
const LIMITE_PAGINAS_SEGURIDAD = 40;
const NOMBRES_DIA = ['DOM', 'LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB'];

// Vista de calendario armada a mano (sin FullCalendar): el proyecto ya trae
// @fullcalendar/react 5.x pero el único plugin de vista de horas disponible
// en node_modules es la versión 4.x (viene de admin-lte), incompatible con
// esa 5.x. En vez de instalar una versión nueva sin poder verificar que
// renderiza bien con React 18, se construyó la grilla con CSS puro.
class AgendaCalendarioModal extends Component {

  constructor() {
    super();
    this.state = {
      cargando: false,
      citas: [],
      fechaSeleccionada: moment().format('YYYY-MM-DD'),
      huboTruncado: false,
      filtroEspecialidad: 'todas',
      especialidadesDisponibles: [],
      popover: null
    };
  }

  abrir = () => {
    this.setState({ popover: null });
    $('#modal-agenda-calendario').modal('show');
    this.cargarTodasLasCitas();
  };

  obtenerFecha = (cita) => cita.fecha;

  obtenerDuracionMin = (cita) => Number((cita.schedule && cita.schedule.interval) || cita.duration || cita.duracion || 20) || 20;

  obtenerTipo = (cita) => ((cita.type || '').toLowerCase().includes('tele') ? 'telemedicina' : 'presencial');

  obtenerNombrePaciente = (cita) => {
    const u = (cita.patient && cita.patient.user) || {};
    return [u.name1, u.name2, u.lastname1, u.lastname2].filter(Boolean).join(' ') || 'Paciente';
  };

  obtenerEspecialidad = (cita) => (cita.specialty && cita.specialty.name) || '';

  obtenerSede = (cita) => (cita.schedule && cita.schedule.sede && cita.schedule.sede.name) || '';

  minutosDelDia = (momentoObj) => momentoObj.hours() * 60 + momentoObj.minutes();

  cargarTodasLasCitas = async () => {
    this.setState({ cargando: true, citas: [], huboTruncado: false });

    let pagina = 1;
    let totalPaginas = 1;
    let acumulado = [];

    try {
      do {
        const response = await axios.get(ApiURL + "/api/Citas/ListAll?numeropagina=" + pagina);
        const datos = (response.data && response.data.data) || [];
        acumulado = acumulado.concat(datos);

        const items = (response.data.pager && response.data.pager.items) || [];
        totalPaginas = items.reduce((max, item) => Math.max(max, Number(item.pagina || item.texto) || 1), 1);

        pagina += 1;
      } while (pagina <= totalPaginas && pagina <= LIMITE_PAGINAS_SEGURIDAD);

      const especialidades = Array.from(new Set(acumulado.map((c) => this.obtenerEspecialidad(c)).filter(Boolean))).sort((a, b) => a.localeCompare(b));

      this.setState({
        citas: acumulado,
        cargando: false,
        huboTruncado: totalPaginas > LIMITE_PAGINAS_SEGURIDAD,
        especialidadesDisponibles: especialidades
      });
    } catch (error) {
      console.log(error);
      this.setState({ cargando: false });
    }
  };

  cambiarSemana = (delta) => {
    this.setState((prev) => ({
      fechaSeleccionada: moment(prev.fechaSeleccionada).add(delta * 7, 'days').format('YYYY-MM-DD'),
      popover: null
    }));
  };

  irAHoy = () => this.setState({ fechaSeleccionada: moment().format('YYYY-MM-DD'), popover: null });

  cambiarFecha = (e) => this.setState({ fechaSeleccionada: e.target.value, popover: null });

  cambiarFiltroEspecialidad = (e) => this.setState({ filtroEspecialidad: e.target.value, popover: null });

  // Muestra el detalle completo (sin cortar) de una cita, en una tarjeta
  // flotante anclada al bloque en el que se hizo clic.
  mostrarDetalle = (e, evento) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();

    const ANCHO_POPOVER = 260;
    const ALTO_ESTIMADO = 170;

    let left = rect.left;
    let top = rect.bottom + 6;

    if (left + ANCHO_POPOVER > window.innerWidth - 12) left = window.innerWidth - ANCHO_POPOVER - 12;
    if (top + ALTO_ESTIMADO > window.innerHeight - 12) top = Math.max(12, rect.top - ALTO_ESTIMADO - 6);

    this.setState({ popover: { evento, left, top } });
  };

  cerrarDetalle = () => this.setState({ popover: null });

  capitalizar = (texto) => (texto || '').trim().toLowerCase().replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));

  imprimirAgenda = () => window.print();

  // Domingo a sábado, igual que la vista semanal de Google Calendar. .day(0)
  // en moment siempre da domingo sin importar el locale (a diferencia de .weekday()).
  diasDeLaSemana = () => {
    const inicioSemana = moment(this.state.fechaSeleccionada).day(0);
    return [0, 1, 2, 3, 4, 5, 6].map((i) => moment(inicioSemana).add(i, 'days'));
  };

  citasDeFecha = (fechaMoment) => {
    const { filtroEspecialidad } = this.state;
    const clave = fechaMoment.format('YYYY-MM-DD');
    return this.state.citas
      .filter((c) => this.obtenerFecha(c) && moment(this.obtenerFecha(c)).format('YYYY-MM-DD') === clave)
      .filter((c) => filtroEspecialidad === 'todas' || this.obtenerEspecialidad(c) === filtroEspecialidad)
      .sort((a, b) => moment(this.obtenerFecha(a)).diff(moment(this.obtenerFecha(b))));
  };

  // Un solo rango de horas para las 7 columnas, así quedan alineadas entre sí.
  calcularRangoSemana = (dias) => {
    let inicioMin = 7 * 60;
    let finMin = 19 * 60;
    let huboCitas = false;

    dias.forEach((dia) => {
      const citasDia = this.citasDeFecha(dia);
      if (!citasDia.length) return;
      huboCitas = true;

      citasDia.forEach((cita) => {
        const inicio = this.minutosDelDia(moment(this.obtenerFecha(cita)));
        const fin = inicio + this.obtenerDuracionMin(cita);
        inicioMin = Math.min(inicioMin, inicio);
        finMin = Math.max(finMin, fin);
      });

      const horario = citasDia[0].schedule;
      if (horario && horario.beginTime) inicioMin = Math.min(inicioMin, this.minutosDelDia(moment(horario.beginTime)));
      if (horario && horario.endTime) finMin = Math.max(finMin, this.minutosDelDia(moment(horario.endTime)));
    });

    if (!huboCitas) return { inicioMin: 7 * 60, finMin: 19 * 60 };

    return {
      inicioMin: Math.max(0, Math.floor((inicioMin - 30) / 60) * 60),
      finMin: Math.min(24 * 60, Math.ceil((finMin + 30) / 60) * 60)
    };
  };

  // Citas que se solapan (o empiezan a la misma hora) se reparten el ancho de
  // la columna en vez de pintarse una encima de otra. Agrupa por "clusters" de
  // solape transitivo y dentro de cada uno asigna la primera columna libre
  // (mismo criterio que usan la mayoría de calendarios tipo Google Calendar).
  asignarColumnasSolapadas = (eventosOrdenados) => {
    let cluster = [];
    let finMaximoCluster = -Infinity;

    const cerrarCluster = () => {
      if (!cluster.length) return;
      const finPorColumna = [];

      cluster.forEach((ev) => {
        let columna = finPorColumna.findIndex((fin) => fin <= ev.inicioMin);
        if (columna === -1) {
          columna = finPorColumna.length;
          finPorColumna.push(ev.finMin);
        } else {
          finPorColumna[columna] = ev.finMin;
        }
        ev.columna = columna;
      });

      cluster.forEach((ev) => { ev.totalColumnas = finPorColumna.length; });
      cluster = [];
    };

    eventosOrdenados.forEach((ev) => {
      if (cluster.length && ev.inicioMin >= finMaximoCluster) {
        cerrarCluster();
        finMaximoCluster = -Infinity;
      }
      cluster.push(ev);
      finMaximoCluster = Math.max(finMaximoCluster, ev.finMin);
    });
    cerrarCluster();
  };

  // Bloques "ocupado" (una cita) y "disponible" (huecos, incluido antes de la
  // primera y después de la última si el rango compartido es más ancho).
  construirEventosDia = (citasDia, inicioMin, finMin) => {
    const ocupados = citasDia.map((cita) => {
      const inicio = this.minutosDelDia(moment(this.obtenerFecha(cita)));
      const duracion = this.obtenerDuracionMin(cita);
      return { tipo: 'ocupado', variante: this.obtenerTipo(cita), inicioMin: inicio, finMin: inicio + duracion, cita };
    }).sort((a, b) => a.inicioMin - b.inicioMin || b.finMin - a.finMin);

    this.asignarColumnasSolapadas(ocupados);

    const eventos = [...ocupados];
    let cursor = inicioMin;

    ocupados.forEach((evento) => {
      if (evento.inicioMin - cursor >= UMBRAL_DISPONIBLE_MIN) {
        eventos.push({ tipo: 'disponible', inicioMin: cursor, finMin: evento.inicioMin, columna: 0, totalColumnas: 1 });
      }
      cursor = Math.max(cursor, evento.finMin);
    });

    if (finMin - cursor >= UMBRAL_DISPONIBLE_MIN) {
      eventos.push({ tipo: 'disponible', inicioMin: cursor, finMin, columna: 0, totalColumnas: 1 });
    }

    return eventos;
  };

  formatoHora = (minutosDia) => moment().startOf('day').add(minutosDia, 'minutes').format('HH:mm');

  renderPopover = (evento) => {
    const cita = evento.cita;
    const nombre = this.obtenerNombrePaciente(cita);
    const especialidad = this.obtenerEspecialidad(cita);
    const sede = this.obtenerSede(cita);
    const tipoLabel = evento.variante === 'telemedicina' ? 'Telemedicina' : 'Presencial';

    return (
      <React.Fragment>
        <div className="m24ac-popover-header">
          <strong>{this.formatoHora(evento.inicioMin)} - {this.formatoHora(evento.finMin)}</strong>
          <button type="button" className="m24ac-popover-cerrar" onClick={this.cerrarDetalle} aria-label="Cerrar">&times;</button>
        </div>
        <div className="m24ac-popover-nombre">{nombre}</div>
        {especialidad ? <div className="m24ac-popover-linea"><i className="fas fa-stethoscope"></i> {especialidad}</div> : null}
        {sede ? <div className="m24ac-popover-linea"><i className="fas fa-map-marker-alt"></i> {sede}</div> : null}
        <div className="m24ac-popover-linea"><i className="fas fa-house-user"></i> {tipoLabel}</div>
      </React.Fragment>
    );
  };

  // Todos los días del mes que contiene la fecha actualmente seleccionada
  // (del 1 al último día), para que el reporte cubra el mes completo.
  diasDelMes = () => {
    const inicioMes = moment(this.state.fechaSeleccionada).startOf('month');
    const totalDias = moment(this.state.fechaSeleccionada).daysInMonth();
    return Array.from({ length: totalDias }, (_, i) => moment(inicioMes).add(i, 'days'));
  };

  // Reporte de impresión: se arma como lista por día (no como grilla), porque
  // una grilla de horas con columnas absolutas no se puede paginar en papel
  // de forma confiable. Cubre el mes completo, no solo la semana en pantalla,
  // y se calcula aparte (no depende de lo que esté renderizado en la grilla).
  //
  // Se monta con un portal directo a document.body (no dentro del modal):
  // si viviera dentro del modal, todo el contenido invisible del calendario
  // (la grilla puede medir miles de píxeles) seguiría ocupando espacio en el
  // flujo normal del documento al imprimir y generaba una hoja extra en
  // blanco. Como hijo directo de <body>, aislarlo en @media print es trivial
  // y no depende de la altura de nada más en la página.
  renderReporteImprimible = () => {
    const nombreInstitucion = sessionStorage.getItem('institution') || '';
    const nombreProfesional = sessionStorage.getItem('nombre_usua') || '';
    const logoInstitucion = ApiURL + "/api/Files?path=" + sessionStorage.getItem('avatar');
    const { filtroEspecialidad } = this.state;

    const diasMes = this.diasDelMes();
    const tituloMes = this.capitalizar(moment(this.state.fechaSeleccionada).locale('es').format('MMMM [de] YYYY'));

    // Solo se listan los días que sí tienen citas: un reporte mensual con 30
    // filas de "Sin citas programadas" sería ruido, no un reporte más visible.
    const diasConCitas = diasMes
      .map((dia) => ({ dia, citas: this.citasDeFecha(dia) }))
      .filter((d) => d.citas.length > 0);

    const { inicioMin, finMin } = this.calcularRangoSemana(diasMes);

    // Total de pacientes atendidos en el mes, y el mismo total repartido por
    // especialidad (junto al conteo de días que ya se mostraba).
    const totalPacientesMes = diasConCitas.reduce((acc, d) => acc + d.citas.length, 0);

    const pacientesPorEspecialidad = {};
    diasConCitas.forEach((d) => {
      d.citas.forEach((cita) => {
        const especialidad = this.obtenerEspecialidad(cita) || 'Sin especialidad';
        pacientesPorEspecialidad[especialidad] = (pacientesPorEspecialidad[especialidad] || 0) + 1;
      });
    });

    const listaPorEspecialidad = Object.entries(pacientesPorEspecialidad).sort((a, b) => b[1] - a[1]);

    return ReactDOM.createPortal(
      <div className="m24ac-imprimible">
        <div className="m24ac-imp-header">
          <img src={logoMedicall} alt="Medicall24" className="m24ac-imp-logo" />
          <div className="m24ac-imp-institucion">
            {sessionStorage.getItem('avatar') ? (
              <img
                src={logoInstitucion}
                alt="Logo institución"
                className="m24ac-imp-logo-institucion"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
            ) : null}
            <div className="m24ac-imp-institucion-texto">
              <span className="m24ac-imp-institucion-etiqueta">Institución</span>
              <strong>{this.capitalizar(nombreInstitucion)}</strong>
            </div>
          </div>
        </div>

        <h1 className="m24ac-imp-titulo">Agenda mensual — {tituloMes}</h1>
        <div className="m24ac-imp-subtitulo">
          {nombreProfesional ? this.capitalizar(nombreProfesional) : ''}
          {filtroEspecialidad !== 'todas' ? ` · Especialidad: ${filtroEspecialidad}` : ''}
          {' · '}{diasConCitas.length} día{diasConCitas.length === 1 ? '' : 's'} con citas
          {' · '}{totalPacientesMes} paciente{totalPacientesMes === 1 ? '' : 's'} atendido{totalPacientesMes === 1 ? '' : 's'}
        </div>

        {listaPorEspecialidad.length > 1 ? (
          <div className="m24ac-imp-porespecialidad">
            <strong>Por especialidad: </strong>
            {listaPorEspecialidad.map(([especialidad, cantidad]) => `${especialidad} (${cantidad})`).join('   ·   ')}
          </div>
        ) : null}

        {diasConCitas.length === 0 ? (
          <div className="m24ac-imp-sin-citas">Sin citas programadas en este mes.</div>
        ) : null}

        {diasConCitas.map(({ dia, citas: citasDia }, indiceDia) => {
          const disponiblesDia = this.construirEventosDia(citasDia, inicioMin, finMin).filter((e) => e.tipo === 'disponible');

          return (
            <div className="m24ac-imp-dia" key={indiceDia}>
              <h2 className="m24ac-imp-dia-titulo">{this.capitalizar(dia.locale('es').format('dddd D [de] MMMM'))}</h2>

              <table className="m24ac-imp-tabla">
                <thead>
                  <tr>
                    <th>Hora</th>
                    <th>Paciente</th>
                    <th>Especialidad</th>
                    <th>Modalidad</th>
                    <th>Sede</th>
                  </tr>
                </thead>
                <tbody>
                  {citasDia.map((cita, indiceCita) => (
                    <tr key={indiceCita}>
                      <td>{moment(this.obtenerFecha(cita)).format('HH:mm')}</td>
                      <td>{this.capitalizar(this.obtenerNombrePaciente(cita))}</td>
                      <td>{this.obtenerEspecialidad(cita)}</td>
                      <td>{this.obtenerTipo(cita) === 'telemedicina' ? 'Telemedicina' : 'Presencial'}</td>
                      <td>{this.obtenerSede(cita)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {disponiblesDia.length ? (
                <div className="m24ac-imp-disponible">
                  <strong>Disponible: </strong>
                  {disponiblesDia.map((e) => `${this.formatoHora(e.inicioMin)}-${this.formatoHora(e.finMin)}`).join('   ·   ')}
                </div>
              ) : null}
            </div>
          );
        })}

        <div className="m24ac-imp-footer">
          Generado el {moment().format('DD/MM/YYYY HH:mm')} · Medicall24
        </div>
      </div>,
      document.body
    );
  };

  render() {
    const { cargando, fechaSeleccionada, huboTruncado } = this.state;
    const dias = this.diasDeLaSemana();
    const { inicioMin, finMin } = this.calcularRangoSemana(dias);

    const horas = [];
    for (let h = Math.floor(inicioMin / 60); h <= Math.ceil(finMin / 60); h++) {
      horas.push(h);
    }

    const alturaGrid = (finMin - inicioMin) * PX_POR_MINUTO;
    const hoy = moment().format('YYYY-MM-DD');
    const ahoraMin = this.minutosDelDia(moment());

    const eventosPorDia = dias.map((dia) => this.construirEventosDia(this.citasDeFecha(dia), inicioMin, finMin));

    const totalCitas = eventosPorDia.reduce((acc, ev) => acc + ev.filter((e) => e.tipo === 'ocupado').length, 0);
    const disponiblesSemana = eventosPorDia.flatMap((ev) => ev.filter((e) => e.tipo === 'disponible'));
    const minutosLibres = disponiblesSemana.reduce((acc, e) => acc + (e.finMin - e.inicioMin), 0);

    const etiquetaMes = moment(dias[3]).locale('es').format('MMMM [de] YYYY');

    return (
      <div className="modal fade" id="modal-agenda-calendario" data-backdrop="static">
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Calendario de citas</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" style={{color: '#fff'}}>&times;</span>
              </button>
            </div>

            <div className="modal-body">

              <div className="m24ac-toolbar">
                <div className="m24ac-nav">
                  <button className="btn btn-secondary btn-sm" onClick={() => this.cambiarSemana(-1)}>
                    <i className="fas fa-chevron-left"></i>
                  </button>
                  <button className="btn btn-secondary btn-sm" onClick={this.irAHoy}>Hoy</button>
                  <button className="btn btn-secondary btn-sm" onClick={() => this.cambiarSemana(1)}>
                    <i className="fas fa-chevron-right"></i>
                  </button>
                  <span className="m24ac-fecha-label">{etiquetaMes}</span>
                  <input type="date" className="form-control form-control-sm" style={{width: 150}} value={fechaSeleccionada} onChange={this.cambiarFecha} />

                  <select className="form-control form-control-sm" style={{width: 190}} value={this.state.filtroEspecialidad} onChange={this.cambiarFiltroEspecialidad}>
                    <option value="todas">Todas las especialidades</option>
                    {this.state.especialidadesDisponibles.map((especialidad) => (
                      <option key={especialidad} value={especialidad}>{especialidad}</option>
                    ))}
                  </select>
                </div>

                <div className="m24ac-leyenda">
                  <div className="m24ac-leyenda-item"><span className="m24ac-swatch" style={{backgroundColor: '#AD1457'}}></span>Presencial</div>
                  <div className="m24ac-leyenda-item"><span className="m24ac-swatch" style={{backgroundColor: '#2a78d6'}}></span>Telemedicina</div>
                  <div className="m24ac-leyenda-item"><span className="m24ac-swatch" style={{backgroundColor: '#f4f6f9', border: '1px dashed #c3c2b7'}}></span>Disponible</div>
                </div>
              </div>

              <div className="m24ac-resumen">
                {totalCitas} cita{totalCitas === 1 ? '' : 's'} esta semana · {disponiblesSemana.length} intervalo{disponiblesSemana.length === 1 ? '' : 's'} disponible{disponiblesSemana.length === 1 ? '' : 's'} ({minutosLibres} min libres)
                {huboTruncado ? ' · algunas páginas antiguas no se cargaron por un límite de seguridad' : ''}
              </div>

              {cargando ? (
                <div className="d-flex justify-content-center">
                  <ReactBootStrap.Spinner animation="border" />
                </div>
              ) : (
                <React.Fragment>

                  <div className="m24ac-semana-header">
                    <div className="m24ac-semana-header-espacio"></div>
                    {dias.map((dia, indice) => (
                      <div className="m24ac-dia-header" key={indice}>
                        <div className="m24ac-dia-nombre">{NOMBRES_DIA[dia.day()]}</div>
                        <div className={`m24ac-dia-numero ${dia.format('YYYY-MM-DD') === hoy ? 'm24ac-dia-numero--hoy' : ''}`}>{dia.format('D')}</div>
                      </div>
                    ))}
                  </div>

                  <div className="m24ac-grid-wrap">
                    <div className="m24ac-horas" style={{height: alturaGrid}}>
                      {horas.map((h) => (
                        <div key={h} className="m24ac-hora" style={{position: 'absolute', top: (h * 60 - inicioMin) * PX_POR_MINUTO, width: '100%'}}>
                          <span>{this.formatoHora(h * 60)}</span>
                        </div>
                      ))}
                    </div>

                    <div className="m24ac-dias-grid">
                      {dias.map((dia, indiceDia) => {
                        const esHoy = dia.format('YYYY-MM-DD') === hoy;
                        const eventos = eventosPorDia[indiceDia];

                        return (
                          <div className="m24ac-columna" key={indiceDia} style={{height: alturaGrid}}>
                            {esHoy && ahoraMin >= inicioMin && ahoraMin <= finMin ? (
                              <div className="m24ac-ahora" style={{top: (ahoraMin - inicioMin) * PX_POR_MINUTO}}></div>
                            ) : null}

                            {eventos.map((evento, indice) => {
                              const top = (evento.inicioMin - inicioMin) * PX_POR_MINUTO + 2;
                              // -6px: deja una separación visible entre citas seguidas (no solapadas en tiempo).
                              const alto = Math.max((evento.finMin - evento.inicioMin) * PX_POR_MINUTO - 6, 34);

                              const totalColumnas = evento.totalColumnas || 1;
                              const anchoPct = 100 / totalColumnas;
                              const leftPct = anchoPct * (evento.columna || 0);
                              // +/-3px: separación horizontal entre citas que sí coinciden en el tiempo.
                              const posicion = {
                                top,
                                height: alto,
                                left: `calc(${leftPct}% + 3px)`,
                                width: `calc(${anchoPct}% - 6px)`
                              };

                              if (evento.tipo === 'disponible') {
                                return (
                                  <div key={indice} className="m24ac-evento m24ac-evento--disponible" style={posicion}>
                                    <div className="m24ac-evento-titulo">Disponible</div>
                                    {alto > 32 ? <div className="m24ac-evento-detalle">{this.formatoHora(evento.inicioMin)}-{this.formatoHora(evento.finMin)}</div> : null}
                                  </div>
                                );
                              }

                              const cita = evento.cita;
                              const nombre = this.obtenerNombrePaciente(cita);
                              const detalle = this.obtenerEspecialidad(cita);

                              return (
                                <div
                                  key={indice}
                                  className={`m24ac-evento m24ac-evento--${evento.variante} m24ac-evento--clic`}
                                  style={posicion}
                                  onClick={(e) => this.mostrarDetalle(e, evento)}
                                  title="Ver detalle completo"
                                >
                                  <div className="m24ac-evento-titulo">{this.formatoHora(evento.inicioMin)} {nombre}</div>
                                  {detalle && alto > 32 ? <div className="m24ac-evento-detalle">{detalle}</div> : null}
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                </React.Fragment>
              )}

            </div>

            <div className="modal-footer justify-content-between">
              <button className="btn btn-secondary" onClick={this.imprimirAgenda}>
                <i className="fas fa-print"></i> Imprimir agenda
              </button>
              <button className="btn btn-danger" data-dismiss="modal">Cerrar</button>
            </div>

          </div>
        </div>

        {this.renderReporteImprimible()}

        {this.state.popover ? (
          <React.Fragment>
            <div className="m24ac-popover-fondo" onClick={this.cerrarDetalle}></div>
            <div className="m24ac-popover" style={{left: this.state.popover.left, top: this.state.popover.top}}>
              {this.renderPopover(this.state.popover.evento)}
            </div>
          </React.Fragment>
        ) : null}

      </div>
    );
  }
}

export default AgendaCalendarioModal;
